/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import MaskedInput from 'react-maskedinput';
import { addCard, UpdateCard } from '../../../../store/User/userActions';
import AuthLoader from '../../../Loader/Auth';

const CardModal = ({ handleDismiss, isEdit, editInfo, addCard, UpdateCard, loading, error }) => {

  // cleanup on dismiss
  useEffect(() => {
    $('#cardModal').on('hide.bs.modal', () => {
      setName('');
      setCardNumber('');
      setExpMonth(null);
      setExpYear(null);
      setCvv(null);
      setNumberInvalid(false);
      setInvalidEdit(false);
      setUserSubmitted(false);
      handleDismiss();
    });
    // $('#cardModal').on('show.bs.modal', () => {
    //   console.log('im showing');
    // });
  }, []);

  const [name, setName] = useState(editInfo && editInfo.billingDetails && editInfo.billingDetails.name ? editInfo.billingDetails.name : null);
  
  const [cardNumber, setCardNumber] = useState('');
  const [numberInvalid, setNumberInvalid] = useState(false);

  const [expMonth, setExpMonth] = useState(editInfo && editInfo.expMonth ? editInfo.expMonth : null);
  const [expYear, setExpYear] = useState(editInfo && editInfo.expYear ? editInfo.expYear : null);
  const [cvv, setCvv] = useState(null);

  const [invalidEdit, setInvalidEdit] = useState(false);

  const [userSubmitted, setUserSubmitted] = useState(false);

  const hideModal = () => $('#cardModal').modal('hide');

  const handleEditCard = (e) => {
    e.preventDefault();

    if (!loading && userSubmitted && !error) {
      hideModal();
      return;
    }

    if (loading || (userSubmitted && !error)) return;

    // need to prevent user from firing API if they have not changed anything
    // first check that all 3 values were populated at the start
    if (
      editInfo &&
      editInfo.billingDetails &&
      editInfo.billingDetails.name &&
      editInfo.billingDetails.name !== null &&
      editInfo.expMonth &&
      editInfo.expYear
    ) {
      // then check that user has changed any of them
      if (
        editInfo.billingDetails.name !== name ||
        editInfo.expMonth !== expMonth ||
        editInfo.expYear !== expYear
      ) {
        UpdateCard({
          id: editInfo.id,
          cardholderName: name,
          expMonth: Number(expMonth),
          expYear: Number(expYear),
        });
      }
      // otherwise show error message
      else {
        setInvalidEdit(true);
        return;
      }
    }
    // if any of the values didnt exist before for some reason, just submit
    else 
    UpdateCard({
      id: editInfo.id,
      cardholderName: name,
      expMonth: Number(expMonth),
      expYear: Number(expYear),
    });
  };

  const handleAddCard = (e) => {
    e.preventDefault();

    if (!loading && userSubmitted && !error) {
      hideModal();
      return;
    }

    if (loading || (userSubmitted && !error)) return;

    if (cardNumber.length < 15) {
      setNumberInvalid(true);
      return;
    }

    addCard({
      name: name,
      number: cardNumber,
      expMonth: Number(expMonth),
      expYear: Number(expYear),
      cvc: cvv,
    });
  };

  useEffect(() => {
    // if card is showing and load state is triggered
    if (loading === true &&
      document.getElementById('cardModal').className.match('show')) {
      setUserSubmitted(true);
    }
  }, [loading]);

  useEffect(() => {
    setExpMonth(editInfo &&
      editInfo.expMonth ? (
      editInfo.expMonth
    ) : null);
    setExpYear(editInfo &&
      editInfo.expYear ? (
      editInfo.expYear
    ) : null);
    setName(editInfo &&
      editInfo.billingDetails &&
      editInfo.billingDetails.name ? (
      editInfo.billingDetails.name
    ) : null);
  }, [editInfo]);

  return (
    <div
      className="modal card-modal"
      id="cardModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">{`${isEdit ? 'Edit' : 'Add'} Card`}</h3>
          </div>
          <div className="modal-body">
            <form onSubmit={isEdit ? handleEditCard : handleAddCard} autoComplete="off">
              <div className="form-group mb-3">
                <label htmlFor="Name">
                  Name on Card
                </label>
                <input
                  className="form-control"
                  id="Name"
                  type="text"
                  pattern="[`'.\-a-zA-Z ]{2,26}"
                  value={name ? name : ''}
                  required
                  onChange={(e) => {
                    setName(e.target.value);
                    if (e.target.value.match(/[^`'.\-a-zA-Z ]/) || e.target.value.length < 2 || e.target.value.length > 26) {
                      e.target.setCustomValidity('Please enter a valid name.');
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }}
                  disabled={userSubmitted && !error}
                />
              </div>
              {isEdit ? null : (
                <div className="form-group mb-3">
                  <label htmlFor="Number">
                    Card Number
                  </label>
                  <MaskedInput
                    mask="1111 1111 1111 1111"
                    id="Number"
                    size={20}
                    value={cardNumber.replace(/[_ ]/g, '')}
                    pattern="[0-9  _]{15,}"
                    className={`form-control${numberInvalid ? ' is-invalid' : ''}`}
                    onChange={(e) => {
                      setCardNumber(e.target.value.replace(/[_ ]/g, ''))
                      if (numberInvalid) setNumberInvalid(e.target.value.replace(/[_ ]/g, '').length < 15)
                    }}
                    required={true}
                    placeholder=''
                    disabled={userSubmitted && !error}
                  />
                  {numberInvalid ? (
                    <label id="NumberError" className="text-danger mt-1 mb-0">
                      * Invalid Card Number
                    </label>
                  ) : null}
                </div>
              )}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="expMonth">
                    Expiry Month
                  </label>
                  <input
                    className="form-control"
                    id="expMonth"
                    type="number"
                    min={1}
                    max={12}
                    maxLength={2}
                    onChange={(e) => setExpMonth(e.target.value)}
                    value={expMonth ? expMonth : ''}
                    required
                    disabled={userSubmitted && !error}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="expYear">
                    Expiry Year
                  </label>
                  <input
                    className="form-control"
                    id="expYear"
                    type="number"
                    min={new Date().getFullYear()}
                    max={new Date().getFullYear() + 50}
                    onChange={(e) => setExpYear(e.target.value)}
                    value={expYear ? expYear : ''}
                    required
                    disabled={userSubmitted && !error}
                  />
                </div>
                {isEdit ? null : (
                  <div className="form-group">
                    <label htmlFor="cvv">
                      CVV
                    </label>
                    <input
                      className="form-control"
                      id="cvv"
                      pattern="\d{3,4}"
                      type="password"
                      inputMode="numeric"
                      minLength={3}
                      maxLength={4}
                      value={cvv ? cvv : ''}
                      required
                      onChange={(e) => {
                        setCvv(e.target.value);
                        if (e.target.value.match(/[^\d]/) || e.target.value.length < 3) {
                          e.target.setCustomValidity('Please enter 3 to 4 numeric characters.');
                        } else {
                          e.target.setCustomValidity("");
                        }
                      }}
                      disabled={userSubmitted && !error}
                    />
                  </div>
                )}
              </div>
              {invalidEdit && (
                <label id="NoChange" className="mb-2">
                  * No field was updated. Please update any of the fields in order to proceed or click "Cancel" to close this form.
                </label>
              )}
              <div className="d-flex justify-content-between">
                <button
                  className="my-account-btn secondary"
                  onClick={hideModal}
                  type="reset"
                  data-dismiss="modal"
                  disabled={loading || (userSubmitted && !loading && !error)}
                >
                  Cancel
                </button>
                <button
                  className="my-account-btn"
                  type="submit"
                // disabled={name.length < 1 || cardNumber.length < 1 || !expMonth || !expYear || !cvv}
                >
                  {userSubmitted && !loading && !error ? 'Done' : isEdit ? 'Edit' : 'Add'}
                  {loading && <AuthLoader />}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div >
    </div >
  );
};

const mapStateToProps = (state) => ({
  error: state.user.cardError,
  loading: state.user.loading,
});

const mapDispatchToProps = { addCard, UpdateCard };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CardModal);
